const checkPhoneValidation = (val, callback, callback2) => {
    if(val.indexOf("_") >= 0) {
        callback("");

        if(callback2 !== undefined) {
            callback2("");
        }
    } else {
        callback(val);
    }
};

export default checkPhoneValidation;
